import { IHttpClient } from "../../lib/http";

export async function regenPropertyCache(
  httpClient: IHttpClient,
  propertyTicker: string,
  forceRegenCache?: boolean,
  token?: string
): Promise<void> {
  return httpClient.post(
    forceRegenCache
      ? `/api/property/${propertyTicker}/cache?forceRegenCache=true`
      : `/api/property/${propertyTicker}/cache`,
    undefined,
    {
      headers: {
        "x-property": propertyTicker,
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    }
  );
}

/**
 * @deprecated Don't use this method, has been added to solve some regen cache issues and shouldn't be
 * used in other places than in the "Regen property calendar" page. Use `regenPropertyCache` instead.
 */
export async function regenPropertyCacheSync(
  httpClient: IHttpClient,
  propertyTicker: string,
  forceRegenCache?: boolean,
  token?: string
): Promise<void> {
  return httpClient.post(
    forceRegenCache
      ? `/api/property/${propertyTicker}/cache-sync?forceRegenCache=true`
      : `/api/property/${propertyTicker}/cache-sync`,
    undefined,
    {
      headers: {
        "x-property": propertyTicker,
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    }
  );
}
